import { styled } from "@mui/material/styles";

// Themes
import theme from "~/components/Common/Theme";

const styledName = "LayoutPage";

export const StyledLayoutBackground = styled("div", { name: styledName })({
  "&": {
    width: "100vw",
    height: "100vh",
    backgroundColor: theme.palette.background.default,
    display: "flex",
  },
});
